export default __webpack_public_path__ + "static/media/shane_portfolio_site.e2e1f744.JPG";